export default __webpack_public_path__ + "static/chance-to-challenge-balthazaurus-scroll-0249e5f0f3e125d104ce8babedaa25a7.gif";